import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { FC, MouseEvent } from "react";
import {
  faCheck,
  faBan,
  faFolder,
  faFolderOpen,
  faFolderPlus,
  faFileSignature,
  faSearch,
  faFileWord,
  faFilePowerpoint,
  faFileExcel,
  faFilePdf,
  faFile,
  faFileCode,
  faComments,
  faEdit,
  faCloudUploadAlt,
  faTrash,
  faTimes,
  faUpload,
  faInfoCircle,
  faCheckCircle,
  faUserCheck,
  faUsers,
  faUser,
  faHistory,
  faUserFriends,
  faLock,
  faSave,
  faPlus,
  faInfo,
  faTags,
  faFileImport,
  faEye,
  faFilter,
  faPrint,
  faBell,
  faEnvelope,
  faExclamationTriangle,
  faPaperPlane,
  faFileMedicalAlt,
  faPenSquare,
  faPenFancy,
  faPenNib,
  faFileImage,
  faBuilding,
  faCaretDown,
  faCaretRight,
  faTimesCircle,
  faCopy,
  faTasks,
  faComment,
  faExclamationCircle,
  faThumbtack,
  faPaperclip,
  faDesktop,
  faCog,
  faRecycle,
  faShare,
  faPhone,
  faMailBulk,
  faHeadset,
  faFileExport,
  faCalendar,
  faMinusCircle,
  faTicketAlt,
  faUserClock,
  faClipboardCheck,
  faDotCircle,
  faArrowDown,
  faArrowUp,
} from "@fortawesome/free-solid-svg-icons";
import { IconProp, SizeProp } from "@fortawesome/fontawesome-svg-core";

const icons: { [key: string]: IconProp } = {
  faCheck,
  faBan,
  faFolder,
  faFolderOpen,
  faFolderPlus,
  faFileSignature,
  faSearch,
  faFileWord,
  faFilePowerpoint,
  faFileExcel,
  faFilePdf,
  faFile,
  faFileCode,
  faComments,
  faEdit,
  faCloudUploadAlt,
  faTrash,
  faTimes,
  faUpload,
  faInfoCircle,
  faCheckCircle,
  faUserCheck,
  faUsers,
  faUser,
  faHistory,
  faUserFriends,
  faLock,
  faSave,
  faPlus,
  faInfo,
  faTags,
  faFileImport,
  faEye,
  faFilter,
  faPrint,
  faBell,
  faEnvelope,
  faExclamationTriangle,
  faPaperPlane,
  faFileMedicalAlt,
  faPenSquare,
  faPenFancy,
  faPenNib,
  faFileImage,
  faBuilding,
  faCaretDown,
  faCaretRight,
  faTimesCircle,
  faCopy,
  faTasks,
  faComment,
  faExclamationCircle,
  faThumbtack,
  faPaperclip,
  faDesktop,
  faCog,
  faRecycle,
  faShare,
  faPhone,
  faMailBulk,
  faHeadset,
  faFileExport,
  faCalendar,
  faMinusCircle,
  faTicketAlt,
  faUserClock,
  faClipboardCheck,
  faDotCircle,
  faArrowDown,
  faArrowUp,
};
interface FontFaProps {
  name: keyof typeof icons;
  size?: SizeProp;
  color?: string;
  style?: React.CSSProperties;
  className?: string;
  onClick?: (event: MouseEvent<SVGSVGElement>) => void;
}
const FontFa: FC<FontFaProps> = ({ name, size, color, style, className, onClick }) => {
  return (
    <FontAwesomeIcon
      icon={icons[name]}
      size={size}
      color={color}
      style={style}
      className={className}
      onClick={onClick}
    />
  );
};

export default FontFa;
